<template>
  <span class="bg-error-1 h-3 w-3 rounded-full"> </span>
</template>
